export const version = '2.37.8';
//# sourceMappingURL=version.js.map